import { ROUTE } from '../../../routes';
import { ButtonTypeTokens, InputStateToken, WIDGET, } from '@voltmoney/schema';
import SharedPropsService, { BUILD_TYPE } from '../../../SharedPropsService';
import { AssetRepositoryMap, AssetRepositoryType, ConfigTokens, getAppHeader, getPrimaryAssetRepositoryForPledge, } from '../../../configs/config';
import { api, StoreKey } from '../../../configs/api';
import _ from 'lodash';
import { AnalyticsEventTracker, LENDER_ID, QUERY_PARAMS, } from '../../../configs/constants';
import { fetchPledgeLimitRepo } from '../unlock_limit/repo';
import { doesContainNonSIPortfolioHolding, getParameters, isASESAllowedForLender, nextStepCredStepper, phonePayRoutes } from '../../../configs/utils';
import { ACTION } from "../../mfFetch/check_limit/types";
import { ACTION as AV } from "./types";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from 'react-native';
let hasChangedInDetails = false;
let hasRedirected = false;
let assetRepository;
export const fetchMyPortfolio = async (action, _datastore, { network, navigateWithClear, setDatastore, navigate, goBack, analytics, instrumentTrack, ...props }) => {
    await setDatastore(action.routeId, "fetchCTA", {
        label: "",
        type: ButtonTypeTokens.LargeOutline,
        loading: true,
    });
    const canGoBack = await SharedPropsService.getConfig(ConfigTokens.IS_MF_FETCH_BACK_ALLOWED);
    console.warn("CAN GO BACK VALUE IS", canGoBack);
    const user = await SharedPropsService.getUser();
    await analytics("eligibility_sucess", { "event": "eligibility_sucess" });
    if (hasChangedInDetails) {
        action.payload.panNumber = user.linkedBorrowerAccounts[0].accountHolderPAN;
        action.payload.phoneNumber =
            user.linkedBorrowerAccounts[0].accountHolderPhoneNumber;
        action.payload.emailId = user.linkedBorrowerAccounts[0].accountHolderEmail;
        if (!action.payload.applicationId) {
            action.payload.applicationId = user.linkedApplications[0].applicationId;
        }
    }
    if (hasRedirected) {
        assetRepository = AssetRepositoryType[action.payload.assetRepository] === "KARVY" ? AssetRepositoryType.CAMS : AssetRepositoryType.KARVY;
    }
    else {
        assetRepository = AssetRepositoryType[action.payload.assetRepository];
    }
    const response = await network.post(api.fetchInitV2, {
        ...action.payload,
        assetRepository: assetRepository,
    }, {
        headers: await getAppHeader(),
        handleFromMF: canGoBack ? false : !hasRedirected
    });
    await setDatastore(action.routeId, "fetchCTA", {
        label: "Get my portfolio",
        type: ButtonTypeTokens.LargeFilled,
        loading: false,
    });
    if (response?.response?.data?.voltErrorCode === "MF_NO_ACCOUNT_FOUND_MATCHING_DETAILS" && !hasRedirected && !canGoBack) {
        hasRedirected = true;
        await fetchMyPortfolio(action, {}, {
            network,
            navigateWithClear,
            setDatastore,
            navigate,
            goBack,
            analytics,
            instrumentTrack, ...props
        });
        return;
    }
    user.linkedApplications[0].currentStepId = _.get(response, "response.data.updatedApplicationObj.currentStepId", response.data.updatedApplicationObj.currentStepId);
    await SharedPropsService.setUser(user);
    /*** Reset to default asset repository type if the user has changed the asset repository type from the settings page */
    await setDatastore(ROUTE.REFRESH_FETCH_OTP, "input", {
        state: InputStateToken.DEFAULT,
        charLimit: AssetRepositoryMap.get(assetRepository).OTP_LENGTH,
    });
    await setDatastore(ROUTE.REFRESH_FETCH_OTP, "subTitle", {
        label: `${AssetRepositoryMap.get(assetRepository).NAME} depository has sent an OTP to `,
    });
    action.payload.assetRepository = assetRepository;
    hasRedirected = false;
    navigate(ROUTE.REFRESH_FETCH_OTP, action.payload);
};
export const checkRefreshCriteria = async (action, _datastore, { navigate, instrumentTrack, removeWidgets, setDatastore, network, analytics, ...props }) => {
    instrumentTrack('VIEW_KFS_BUTTON_CLICKED');
    await setDatastore(action.routeId, action.payload.widgetId, {
        label: '',
        type: ButtonTypeTokens.LargeOutline,
        loading: true,
    });
    const applicationId = (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    const response = await network.get(`${api.checkRefreshCriteria}${applicationId}`, { headers: await getAppHeader() });
    let user = await SharedPropsService.getUser();
    let emailId = user.linkedBorrowerAccounts[0].accountHolderEmail;
    let phoneNumber = user.linkedBorrowerAccounts[0].accountHolderPhoneNumber;
    let pan = user.linkedBorrowerAccounts[0].accountHolderPAN;
    assetRepository = AssetRepositoryType.CAMS;
    // Fetching CAMS again if we receive the refresh portfolio criteria to be true
    if (response.data.isRefreshPortfolioRequired) {
        await fetchMyPortfolio({
            routeId: ROUTE.MF_FETCH_PORTFOLIO,
            type: ACTION.FETCH_MY_PORTFOLIO,
            payload: {
                applicationId,
                emailId,
                phoneNumber,
                panNumber: pan,
                assetRepository,
            },
        }, {}, { navigate, instrumentTrack, setDatastore, removeWidgets, network, analytics, ...props });
    }
    else {
        await sendOtpForPledgeConfirm({
            routeId: ROUTE.PLEDGE_CONFIRMATION,
            type: AV.SEND_OTP_FOR_PLEDGE_CONFIRM,
            payload: {
                value: action.payload.value,
                widgetId: 'ctaButton',
                isResend: false,
                portFolioArray: action.payload.portFolioArray,
            },
        }, {}, { navigate, instrumentTrack, setDatastore, removeWidgets, network, analytics, ...props });
    }
};
export const sendOtpForPledgeConfirm = async (action, _datastore, { instrumentTrack, analytics, network, navigate, setDatastore }) => {
    await setDatastore(ROUTE.ALERT_PAGE, 'alert', {
        loading: true,
    });
    await setDatastore(action.routeId, action.payload.widgetId, {
        label: '',
        type: ButtonTypeTokens.LargeOutline,
        loading: true,
    });
    AssetRepositoryMap.get(AssetRepositoryType.CAMS).LIST = [];
    AssetRepositoryMap.get(AssetRepositoryType.KARVY).LIST = [];
    console.warn("ASSET REPO MAP TYPE ", AssetRepositoryMap);
    let primaryType = await getPrimaryAssetRepositoryForPledge();
    let toBePledgedAssets = await SharedPropsService.getToBePledgedAssets();
    toBePledgedAssets.forEach(item => {
        if (item.pledgedUnits > 0) {
            AssetRepositoryMap.get(AssetRepositoryType[item.assetRepository]).LIST.push({
                ...item,
                is_pledged: true,
            });
        }
    });
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    console.log("Asset repo map reveived $$$$", AssetRepositoryMap);
    /**** check if user has empty cams portfolio then switch asset repository type ****/
    if (AssetRepositoryMap.get(AssetRepositoryType.CAMS).LIST.length === 0 ||
        AssetRepositoryMap.get(AssetRepositoryType.CAMS).IS_PLEDGED) {
        primaryType = AssetRepositoryType.KARVY;
    }
    if (AssetRepositoryMap.get(AssetRepositoryType.KARVY).LIST.length === 0) {
        primaryType = AssetRepositoryType.CAMS;
    }
    const body = {
        applicationId: applicationId,
        assetRepository: primaryType,
        portfolioItemList: AssetRepositoryMap.get(primaryType).LIST,
    };
    /** actual api call with body */
    const response = await network.post(api.pledgeCreateV2, body, {
        headers: await getAppHeader(),
    });
    const data = _.get(response, 'data.stepResponseObject');
    if (_.get(response, 'data.status') === 'SUCCESS') {
        analytics(AnalyticsEventTracker.borrower_mf_pledge_init['Event Name'], {
            ...AnalyticsEventTracker.borrower_mf_pledge_init,
        });
        console.log("Action received is", action);
        await navigate(ROUTE.PLEDGE_VERIFY, {
            assetRepository: primaryType,
            sendOtpForPledgeConfirmAction: action,
            identifier: response.data.stepResponseObject.identifier,
            otpChannel: response.data.stepResponseObject.otpChannel,
            noOfDigits: response.data.stepResponseObject.noOfDigits
        });
    }
    await setDatastore(action.routeId, action.payload.widgetId, {
        label: 'Confirm & get OTP',
        type: ButtonTypeTokens.LargeFilled,
        loading: false,
    });
};
export const onLoad = async (action, _datastore, { instrumentTrack, navigate }) => {
    const user = await SharedPropsService.getUser();
    const authCAS = await SharedPropsService.getAuthCASResponse();
    const pledgeLimitResponse = authCAS
        ? { data: authCAS.stepResponseObject.availableCAS }
        : await fetchPledgeLimitRepo().then(response => ({
            data: response.stepResponseObject.tobePledgedPortfolio,
        }));
    let lenderId;
    if (await SharedPropsService.getElevateFlow()) {
        lenderId = pledgeLimitResponse?.data?.updatedApplicationObj?.lenderAccountId;
    }
    else {
        lenderId = user.linkedApplications[0].lenderAccountId;
    }
    const routeId = await AsyncStorage.getItem(StoreKey.ROUTE_ID);
    if (isASESAllowedForLender(lenderId) &&
        doesContainNonSIPortfolioHolding(pledgeLimitResponse.data) &&
        routeId === ROUTE.PLEDGE_CONFIRMATION) {
        if (!await SharedPropsService.getIsJointHolderOpened()) {
            await navigate(ROUTE.JOINT_HOLDER_NOTIFY, {});
        }
    }
};
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const activateAsset = async (action, _datastore, { navigateToBase, network, setDatastore, instrumentTrack }) => {
    instrumentTrack('LOAN_OFFER_ACCEPT_CTA_CLICKED');
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = Platform.OS === 'web' ? getParameters(url) : {};
    const utmSource = params?.utm_source;
    const isFromPhonePe = params?.platform === "PHONEPE" /* AppPlatform.PHONEPE */;
    await setDatastore(action.routeId, action.payload.widgetId, {
        loading: true,
    });
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    const response = await network.get(`${api.activateAsset}${applicationId}`, { headers: await getAppHeader() });
    // block the user if save API response is not there
    await setDatastore(action.routeId, action.payload.widgetId, {
        loading: false,
    });
    const user = await SharedPropsService.getUser();
    const buildType = SharedPropsService.getBuildType();
    user.linkedApplications[0] = response.data.updatedApplicationObj;
    await SharedPropsService.setUser(user);
    const routeObj = await nextStepCredStepper();
    let isFromBajaj = user?.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.BAJAJ;
    const isFromBharatPe = await SharedPropsService.getAppPlatform() === "BHARAT_PE" /* AppPlatform.BHARAT_PE */;
    const isFromSecondBharatPe = await SharedPropsService.getAppPlatform() === "BHARAT_PE_2" /* AppPlatform.BHARAT_PE_2 */;
    if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ && utmSource != QUERY_PARAMS.PHONE_PE_FJ) {
        await navigateToBase(ROUTE.PHONE_PAY_PAGE);
    }
    else if (isFromPhonePe && isFromBajaj) {
        await navigateToBase(ROUTE.PHONE_PAY_PAGE);
    }
    else if (((isFromBharatPe || isFromSecondBharatPe) && buildType === BUILD_TYPE.BORROWER_PRODUCTION) && !phonePayRoutes.includes(routeObj.routeId)) {
        await navigateToBase(ROUTE.PHONE_PAY_PAGE);
        return;
    }
    else {
        await navigateToBase(routeObj.routeId, routeObj.params);
    }
};
export const goToKfs = async (action, _datastore, { navigate, instrumentTrack, removeWidgets }) => {
    instrumentTrack('VIEW_KFS_BUTTON_CLICKED');
    await removeWidgets(ROUTE.KFS_SCREEN, [{ id: 'KFS_Screen_Page', type: WIDGET.KFS_PAGE }]);
    await navigate(ROUTE.KFS_SCREEN);
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const goToStateSelectionPage = async (action, _datastore, { navigate }) => {
    const stateDutyStamp = action.payload.stateDutyStamp;
    await navigate(ROUTE.STATE_SELECTION, { stateDutyStamp: stateDutyStamp });
};
export const goToFaq = async (action, _datastore, { instrumentTrack, navigate }) => {
    instrumentTrack("FAQ_BUTTON_CLICKED", { "page": "confirm_pledge" });
    await navigate(ROUTE.FAQ);
};
export const trackInterestAndChargesCustomer = async (action, _datastore, { instrumentTrack, navigate }) => {
    const type = action.payload.type;
    instrumentTrack(type);
};
